import siteConfig from "site-config";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { COLLECTIONS, MUTATE_OPERATIONS_SENT } from "constants/action-types";
import { mapToOperation } from "./helpers/mapToOperation";
import { getAndIncrementRequestId } from "./helpers/getAndIncrementRequestId";
import { fromJS, List, Set } from "immutable";
import { mapSetOperation } from "actions/mutate";
import { getSnapshot } from "reducers/selectors/mutate";
import { stringify } from "querystring";
import { updateValidationItemAuthor } from "actions/collections/collection-validation-log";

export const mutateValidationLog = (action$, state) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.VALIDATION_LOG.MUTATE)
        .map(({ payload }: { payload: { key: string; newLog: nuorder.collection.validation_log.ValidationLog } }) => {
            const { key, newLog } = payload;
            return mapSetOperation("export_validation_status", key, fromJS({ struct_value: newLog }));
        });

export const validationLogSync = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.VALIDATION_LOG.SYNC.START)
        .filter(({ payload: { objectId } }) => {
            const { mutate } = store.getState();
            const { sentMutations, uncommittedMutations } = mutate;
            const sentMutation = sentMutations.get(objectId);
            const uncommittedMutation = uncommittedMutations.get(objectId) || List();

            return !sentMutation && !!uncommittedMutation.size;
        })
        .map(({ payload }) => {
            const { collection, mutate } = store.getState();
            const { committedHEADs, uncommittedMutations } = mutate;
            const { sessionId, merchantId } = collection;
            const { objectId } = payload;

            const committedHEAD = committedHEADs.get(objectId);

            const operations = [];

            uncommittedMutations.getIn([objectId, 0]).operations.forEach((operation) => {
                const { set } = mapToOperation(operation);
                if (set) {
                    operations.push({ set: { ...set, key: operation.key, value: set.value.struct_value } });
                }
            });

            const requestId = getAndIncrementRequestId(objectId);
            const revision = parseInt(committedHEAD.revision, 10) + 1;
            const command = {
                operations,
                merchant_id: merchantId,
                req_id: requestId,
                revision,
            };

            store.dispatch({
                type: MUTATE_OPERATIONS_SENT,
                payload: {
                    requestId,
                    objectId,
                    revision,
                    objectType: committedHEAD.object_type,
                    sentMutationsIndex: 0,
                },
            });
            return { command, sessionId, requestId, collectionId: committedHEAD.document_id, merchantId };
        })
        .concatMap(({ collectionId, requestId, sessionId, merchantId, command }) => {
            const url = `/v1/collections/${collectionId}/export_validation_status/mutate?sid=${sessionId}&req_id=${requestId}`;
            return ajax({
                body: { ...command, merchant_id: merchantId },
                method: "POST",
                url: siteConfig.goAPI + url,
            }).map(() => ({ type: COLLECTIONS.COLLECTION.VALIDATION_LOG.SYNC.COMPLETE }));
        });
};

let fetchedRevisions = Set<string>();
export const fetchAuthorInfo = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.VALIDATION_LOG.AUTHORS.FETCH.START)
        .map(({ payload }) => payload)
        .flatMap(({ collectionId }) => {
            const state = store.getState();
            const objectId = getSnapshot(state, collectionId)?.getIn([
                "export_validation_status_object_id",
                "ref",
                "object_id",
            ]);
            if (!objectId) {
                return [];
            }

            const revision = state.mutate.committedHEADs.get(objectId)?.revision;

            if (!revision || fetchedRevisions.has(revision)) {
                return [];
            }

            const { collection } = state;
            const query = {
                object_id: objectId,
                sid: collection.sessionId,
                with_snapshot: true,
                revision,
                merchant_id: collection.merchantId,
            };
            return ajax(`${siteConfig.goAPI}/v1/collections/${collectionId}/${objectId}?${stringify(query)}`)
                .map(({ response }) => response)
                .flatMap(({ object }) => {
                    fetchedRevisions = fetchedRevisions.add(revision);
                    const { fields } = object.mutable_map;
                    const actions = [];
                    if (fields) {
                        actions.push(
                            ...Object.keys(fields).map((validationLogLabel) => {
                                const { user_name, user_email } = fields[validationLogLabel].struct_value;
                                return updateValidationItemAuthor(validationLogLabel, user_name, user_email);
                            })
                        );
                    }
                    return actions;
                });
        });
};
